import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stat",
  "use": "icon-stat-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stat\"><path d=\"M816.9 212.6C746.5 139.5 649.4 98.1 548 98.2c-9.2 0.1-16.6 7.7-16.6 16.9v373.8c-0.1 6 3.1 11.6 8.3 14.7l315 186.8c2.5 1.5 5.4 2.3 8.3 2.4 6 0 11.5-3.3 14.4-8.5 33.5-59.7 51-127 50.9-195.4 0.5-103.2-39.5-202.4-111.4-276.3z m39.7 439.7L564.5 479.1V132.5C752 144.4 897.3 301 895.2 488.8c0 56.8-13.2 112.7-38.6 163.5zM809.5 720c-1-4.3-3.7-8.1-7.6-10.3l-307-182V163.8c0.1-9.2-7.2-16.8-16.5-17h-0.1c-101.5 0-198.6 41.3-268.9 114.4-71.8 74-111.8 173.2-111.3 276.3-0.1 68.4 17.4 135.7 50.9 195.4 32.7 58.1 79.8 106.8 136.7 141.4 118.5 71.9 267.2 71.9 385.8 0C728.4 839.7 775.4 791 808 732.9c2.2-3.9 2.8-8.5 1.5-12.9zM131.2 537.5c-2.1-187.8 143.2-344.4 330.6-356.3v346.5L169.8 701c-25.4-50.7-38.6-106.7-38.6-163.5z m347.2 356.8c-119.1-0.8-229.4-62.7-292.1-163.9l292.1-173.3 292.3 173.3c-62.8 101.2-173.2 163.1-292.3 163.9z\" p-id=\"30642\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-stat.svg
// module id = Mncj
// module chunks = 175